import { combineReducers } from 'redux';

import markets from './marketplace';
import merchants from './merchants';
import modals from './modals';
import order from './order';
import variations from './variations';
import update from './Update';

export default combineReducers({
  markets,
  merchants,
  modals,
  order,
  variations,
  update,
});
